

































import {Component, Vue} from "vue-property-decorator";
import {RouterStore} from "@/interfaces/store-interfaces/router-store.interface";

@Component({})
export default class Footer extends Vue {
  baseUrl = process.env.VUE_APP_PUBLIC_URL;
  route = RouterStore.ROUTE_NAME;
  routePath = RouterStore.ROUTE_PATH;

  async openLink(routeName: RouterStore.ROUTE_NAME, showFavorite: boolean = false) {
    let routerParams: any = { routeName };
    if (showFavorite) this.$store.commit('rhizome/setPropertyInState', { name: 'showFavorites', value: showFavorite });

    await this.$store.dispatch('routerStore/openPage', routerParams);
  }

  closeModal() {
    top.postMessage({ action: 'close-modal' }, window.location.origin)
  }

  get isKiosk() {
    return this.$store.state.rhizome.kioskMode;
  }
}
